import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { NFMSRealTimeAlarmsSyncResponse } from '../../types';
import { NFMSFilter } from '../../types/records/feeder-master-data';

export const realTimeAlarmsSyncNFMSEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'nfmsApi'
  >
) => ({
  getRealTimeAlarmsSyncNFMS: builder.mutation<
    NFMSRealTimeAlarmsSyncResponse,
    NFMSFilter
  >({
    query: (data) => ({
      url: `real_time_alarms/consumers/`,
      method: 'POST',
      body: data
    })
  })
});
